import { FacilityState } from "./Stores/types";
import BiService from "Services/BiService";

class Calendar {
    dateFilter: any;
    daysToShowFilter: number;
    providersFilter: string[];
    userProviderChecked: boolean;
    visitTypesFilter: string[];
    cocFilter: string;
    showCancelledVisits: boolean;
    showNonOfficeHours: boolean;
    isTimelineView: boolean;
    showExpandedTimeline: boolean;
    selectedSavedFilter: string;
    savedFiltersChecked: boolean;

    constructor() {
        this.dateFilter = null;
        this.daysToShowFilter = 1;
        this.providersFilter = [];
        this.userProviderChecked = false;
        this.visitTypesFilter = [];
        this.cocFilter = "";
        this.showCancelledVisits = false;
        this.showNonOfficeHours = false;
        this.isTimelineView = false;
        this.showExpandedTimeline = false;
        this.selectedSavedFilter = "";
        this.savedFiltersChecked = false;
    }
}

class User {
    username: string;
    userId: string;
    userProfileImageUrl: string;
    userProfileImage: string;
    userDiscipline: string;
    userRoles: string[];
    facilityList: NetHealth.EHR.Domain.UiModels.FacilityModel[];
    editingCriticalFields: boolean;
    calendar: Calendar;
    redirectDate: string;
    displayProgressNotePanelInVisitWorkflow: boolean;
    isPatientPanelCollapsed: boolean;
    isActivityFeedCollapsed: boolean;
    isVerticalWorkflowCollapsed: boolean;
    isProgressNoteCollapsed: boolean;
    isSchedulerFilterPanelCollapsed: boolean;
    displayVerticalWorkflow: boolean;
    copiedVisitInfo: any;
    schedulerShowUnavailableProviders: boolean;
    isFrontDeskUser: boolean;
    billingUserId: number;
    myReportsOpenInNewWindow: boolean;

    constructor() {
        this.username = '';
        this.userId = '';
        this.userProfileImageUrl = '';
        this.userProfileImage = '';
        this.userDiscipline = '';
        this.facilityList = [];
        this.editingCriticalFields = false;
        this.calendar = new Calendar();
        this.displayProgressNotePanelInVisitWorkflow = false;
        this.redirectDate = '';
        this.isPatientPanelCollapsed = false;
        this.isActivityFeedCollapsed = false;
        this.isVerticalWorkflowCollapsed = false;
        this.isProgressNoteCollapsed = false;
        this.isSchedulerFilterPanelCollapsed = false;
        this.displayVerticalWorkflow = false;
        this.copiedVisitInfo = null;
        this.schedulerShowUnavailableProviders = false;
        this.isFrontDeskUser = false;
        this.myReportsOpenInNewWindow = false;
    }
}

class ClientSession {
    private static instance: ClientSession;

    applicationName: string;
    user: User;
    enableClientSideErrorLogging: boolean;
    connectionsDocumentTypes: string[];
    taskDrawerStateIsOpen: boolean;
    clientSessionHeartBeatInterval: number;
    redirectOn401: boolean;
    eligibilitySignalRHubURL: string;
    rootStore: any;
    xFitSignalRHubUrl: string;
    medicationHistorySignalRHubUrl: string;
    importRequestSignalRHubUrl: string;
    biServerUrl: string;
    publicIpAddress: string;

    get facility(): FacilityState {
        return this.rootStore.state.facility;
    }

    constructor() {
        this.applicationName = "";
        this.user = new User();
        this.enableClientSideErrorLogging = false;
        this.connectionsDocumentTypes = [];
        this.taskDrawerStateIsOpen = true;
        this.redirectOn401 = false;
        this.eligibilitySignalRHubURL = "";
        this.xFitSignalRHubUrl = "";
        this.medicationHistorySignalRHubUrl = "";
        this.importRequestSignalRHubUrl = "";
        this.biServerUrl = '';
        this.publicIpAddress = '';

        this.rootStore = {state: {facility: {}}};
    }

    static getInstance(): ClientSession {
        if (typeof this.instance === 'undefined') {
            this.instance = new ClientSession();
        }
        return this.instance;
    }

    biLogout() {
        var biService = new BiService({ biServerUrl: this.biServerUrl, isExternal: true });
        biService.logout();
    }
}

var instance = ClientSession.getInstance();
export default instance;